import { render } from "./BatchClassTraining.vue?vue&type=template&id=62948226&ts=true"
import script from "./BatchClassTraining.vue?vue&type=script&lang=ts"
export * from "./BatchClassTraining.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__